if (customElements.get("gallery-section") === undefined) {
  class GallerySection extends HTMLElement {
    constructor() {
      super();
  
      const swiperElement = this.querySelector(".swiper");
      const swiper = new Swiper(swiperElement, {
        loop: true,
        navigation: {
          nextEl: this.querySelector(".gallery-swiper-next"),
          prevEl: this.querySelector(".gallery-swiper-prev"),
        },
      });
  
      const gallerySwiper = this.querySelector(".gallery-swiper");
      const closeSwiper = this.querySelector(".gallery-swiper-close");
      let openTrigger;
  
      const openSwipers = this.querySelectorAll("[data-open-swiper]");
      openSwipers.forEach((element) => {
        const index = element.dataset.openSwiper;
        element.addEventListener("click", () => {
          openTrigger = element;
          gallerySwiper.classList.remove("hidden");
          swiper.slideToLoop(index);
          closeSwiper.focus();
        });
      });
  
      const closeGallery = () => {
        gallerySwiper.classList.add("hidden");
        openTrigger?.focus();
      };
      closeSwiper.addEventListener("click", closeGallery);
      gallerySwiper.addEventListener("keydown", (event) => {
        if (event.key === "Escape") closeGallery();
      });

      // this.resizeImage();

      const _this = this;
      // window.addEventListener("resize", function() {
      //   const images = _this.querySelectorAll('.multi-column__item img');  
      //   images.forEach(image => image.style.height = 'auto');
      //   _this.resizeImage();
      // })
    }

    resizeImage() {
      let height = 0;
      const images = this.querySelectorAll('.multi-column__item img');

      if (document.querySelector('.first-gallery-section .multi-column__item img')) {
        height = document.querySelector('.first-gallery-section .multi-column__item img').clientHeight;
      } else {
        images.forEach(image => {
          if (height < image.clientHeight) {
            height = image.clientHeight;
          }
        });
      }

      images.forEach(image => {
        image.style.height = `${height}px`;
      });
    }
  }
  
  customElements.define("gallery-section", GallerySection);
}
